/** @jsxImportSource @emotion/react */

import { FeatureFlagService } from '@weberus/feature-flag';
import { featureFlagsConfig } from '@weberus/ui/conf/feature-flag-config';

import { StylesDotLoader as Styles, StyledDotLoader as Styled } from './spinner.styles';

export function Spinner(): React.ReactNode {
  const featureFlagService = new FeatureFlagService(featureFlagsConfig);

  // eslint-disable-next-line @typescript-eslint/no-unused-vars -- 사용 예시
  const isFeature3Enabled = featureFlagService.isFeatureEnabled('feature3');

  return (
    <Styled.LoadingContainer>
      <Styled.Container>
        <div css={Styles.dot} />
        <div css={Styles.dot} />
        <div css={Styles.dot} />
      </Styled.Container>
    </Styled.LoadingContainer>
  );
}
